const TextSearchResultItemSkeleton = () => {
  return (
    <div className="flex w-full flex-row items-center justify-between gap-4 py-1">
      <div className="flex items-center gap-2">
        <div className="size-4 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-[190px] animate-pulse rounded bg-gray-200" />
      </div>
      <div className="size-4 animate-pulse rounded bg-gray-200" />
    </div>
  )
}

export default TextSearchResultItemSkeleton
